import { render, staticRenderFns } from "./WarrantyTiers.vue?vue&type=template&id=683f9fa0&scoped=true&"
import script from "./WarrantyTiers.vue?vue&type=script&lang=js&"
export * from "./WarrantyTiers.vue?vue&type=script&lang=js&"
import style0 from "./WarrantyTiers.vue?vue&type=style&index=0&id=683f9fa0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683f9fa0",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/WarrantyTiers.vue
// module id = 173
// module chunks = 0